module.exports = __webpack_public_path__ + "static/media/varsha_she.c384de6a.jpg";